
<HomeNavBar @new_report="addReportToHome" @addPortal="addNewPortal" @newSegment="addNewSegement" @new_temp_post="addTemporaryPost" @new_temphub_post="addTemporaryHubPost"
@active-profile-loaded="onActiveProfileLoaded"/>
<InactivityModal/>

<!-- Main Content -->
<!-- <section class="h-100"> -->
  <div class="row content-section h-100">
    <div class="col-lg-3 d-none d-xl-block h-100">
      <AllPortals @portal_selected="fetchPostsByPortal" @portalAccepted="handlePortalAccepted" ref="portals"/>
    </div>


    <!-- Middle Content -->
    <div class="col-lg-6 col-md-12 col-12 scrollable-container" ref="scrollContainer" @scroll="handleScroll">
      <div class="card rounded-5 border-0 shadow-sm p-1 mt-2 m-3 bg-banner-gradient">
      <div class="mt-4 banner-pills">
        <!-- Mobile & iPad View: Left & Right Alignment -->
        <div class="d-flex d-md-none justify-content-between w-100">
          <ul class="pills-billing-tab nav nav-pills  w-100" id="pills-billing-tab" role="tablist">
            <li class="nav-item flex-fill text-start" role="presentation">
              <button class="nav-link active w-100 text-start px-3" id="normal_loans_tab" data-bs-toggle="pill"
                data-bs-target="#normal_loans_info" type="button" role="tab" aria-controls="normal_loans_info"
                aria-selected="true">
                Your Feed
              </button>
            </li>
            <li class="nav-item flex-fill text-end d-none" role="presentation">
              <button class="d-none nav-link w-100 text-end px-3" id="top_loans_tab" data-bs-toggle="pill"
                data-bs-target="#top_loans_info" type="button" role="tab" aria-controls="top_loans_info"
                aria-selected="false">
                Your Voice
              </button>
            </li>
          </ul>
        </div>

        <!-- iPad (md) & Desktop View: Centered Tabs -->
        <div v-if="!cbo_domain" class="d-none d-md-flex justify-content-center w-100 banner-pills">
          <ul class="pills-billing-tab nav nav-pills mb-3" id="pills-billing-tab-md" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active text-xxs fw-500 px-4" id="normal_loans_tab_md" data-bs-toggle="pill"
                data-bs-target="#normal_loans_info" type="button" role="tab" aria-controls="normal_loans_info"
                aria-selected="true">
                Your Feed
              </button>
            </li>
            <li class="nav-item ms-4 d-none" role="presentation">
              <button class=" d-none nav-link text-xxs fw-500 px-4" id="top_loans_tab_md" data-bs-toggle="pill"
                data-bs-target="#top_loans_info" type="button" role="tab" aria-controls="top_loans_info"
                aria-selected="false">
                Your Voice
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="post-section mt-3 overflow-auto p-3 h-150  full-width-mobile scrollable-container">
      <CreateFeed v-if="token_exists && !cbo_domain"  @new_report="addReportToHome" @addPortal="addNewPortal" @newSegment="addNewSegement" @new_temp_post="addTemporaryPost"
      :active-profile="activeProfile"/>
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="normal_loans_info" role="tabpanel" aria-labelledby="normal_loans_tab">
            <div class="temporary-post posting-loader-card" v-if="temporaryPost" id="temp-post">
              <div class="posting-loader-icon" aria-hidden="true">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
              </div>
              <div class="posting-loader-content">
                <div class="d-flex align-items-center justify-content-between gap-2">
                  <p class="mb-0 fw-bold text-xs">Posting your feed</p>
                  <span class="posting-loader-status">Saving</span>
                </div>
                <p class="mb-2 text-muted text-xxs text-truncate">{{ temporaryPost.report_name || 'Feed' }}</p>
                <div class="posting-loader-track" aria-hidden="true">
                  <span></span>
                </div>
              </div>
            </div>
            <div v-if="is_loading" class="text-center py-5 w-100">
            <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 mb-0 text-muted">Loading feeds...</p>
          </div>
          <div v-else>
            <div v-if="reports.length" >
                <div v-for="report in reports"
              :key="report.id"
              :id="'post-' + report.id"
              class="card card-hover mb-4 p-3 d-flex flex-column border-bottom rounded-5 border-0 full-width-mobile shadow report-card">
            <div class="row">
              <div class="col p-3">
                    <div class="d-flex align-items-start gap-3">
                  <!-- Profile Picture -->
                  <img
                    v-if="!dwypd_domain"
                    :src="report.base_profile?.profile_type === 'personal'
                                ? (report.base_profile?.user?.profile?.profile_files?.[0]?.file?.url || require('@/assets/images/user.png'))
                                : (report.base_profile?.company?.base_profile?.profile_files?.[0]?.file?.file_url || require('@/assets/images/user.png'))"
                    class="profile-image rounded-5 profile-list-avatar">

                  <div class="flex-grow-1">
                          <div class="pe-2">
                      <div class="d-flex justify-content-between align-items-start">
                        <div>
                          <p v-if="!dwypd_domain" class="fw-500 mt-1 lh-base text-xxs me-4">
                            <!-- Name -->
                            <span
                              v-if="report?.base_profile?.profile_type?.toLowerCase().trim() === 'personal'"
                              @click="view_profile(report.base_profile?.user?.id)">
                              {{ report.base_profile?.user?.first_name }} {{ report.base_profile?.user?.last_name }}
                            </span>
                            <span v-else @click="view_company(report)">
                              {{ report.base_profile?.company?.company_name || 'Company Name' }}
                            </span>

                            <!-- Topic Badge -->
                            <span class="badge bg-warning text-dark mx-2 text-white shadow-sm">
                              <i class='bx bxs-bulb'></i>{{ report.topic_name || '' }}
                            </span>

                            <!-- Pin Icon -->
                            <span v-if="report.is_pinned"><i class='bx bxs-pin'></i></span>

                            <!-- Date -->
                            <br>
                            <span class="text-xxs">
                              <i class="bx bxs-stopwatch"></i> {{ report.publication_date }}
                            </span>
                          </p>
                        </div>

                        <!-- Three Dots Menu -->
                        <div class="dropstart" @click.stop
                          v-if="String(report.base_profile?.user?.id) === String(user_details.user_id) && token_exists">
                          <a href="" class="fw-bold text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <i class="bi bi-three-dots-vertical"></i>
                          </a>
                          <ul class="dropdown-menu custom-dropdown lh-1" aria-labelledby="dropdownMenuButton">
                            <a v-if="user_details.user_role === 'admin'"
                              class="dropdown-item text-xxs border-bottom fw-bold" href=""
                              @click.prevent="togglePinReport(report)">
                              <i :class="report.is_pinned ? 'bx bx-pin fs-6' : 'bx bxs-pin fs-6'"></i>
                              {{ report.is_pinned ? 'Unpin' : 'Pin' }}
                            </a>
                            <li>
                              <a class="dropdown-item text-xxs fw-bold" href=""
                                data-bs-toggle="modal"
                                data-bs-target="#edit_report_modal"
                                @click="edit_report(report)"
                                v-if="report.total_comments === 0 && report.total_likes === 0">
                                <i class="bx bxs-edit fs-6"></i> Edit
                              </a>
                            </li>
                            <li>
                              <a class="dropdown-item text-xxs fw-bold" href=""
                                @click.prevent="deleteReport(report.id)">
                                <i class='bx bxs-trash-alt fs-6'></i> Delete
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Report Description -->
                <p class="fw-500 mt-2" v-if="report.name">{{ report.name }}</p>
                <div class="quill-wrapper">
                    <div
    v-html="displayedDescription(report)"
    :class="['quill-content','fs-6','lh-lg', { expanded: isExpanded(report.id) }]"
  ></div>

  <!-- Read More / Read Less Toggle -->
  <span
    v-if="report.description && report.description.length > 0 && report.description.length > maxLength"
    class="text-secondary cursor-pointer text-xxs ms-1"
    @click="toggleDescription(report.id)"
  >
    {{ isExpanded(report.id) ? 'Read Less' : 'Read More' }}
    <i v-if="!isExpanded(report.id)" class="bx bx-down-arrow-circle"></i>
    <i v-else class="bx bx-up-arrow-circle"></i>
  </span>
                  </div>
                 <!-- Images -->
                  <!-- ✅ IMAGE FILES -->
                      <div v-if="getCarouselImages(report).length" class="report-carousel">
                      <div :id="'carousel-' + report.id" class="carousel slide">
                        <!-- Indicators -->
                        <div v-if="getCarouselImages(report).length>1" class="carousel-indicators">
                          <button
                            v-for="(src, i) in getCarouselImages(report)"
                            :key="'indicator-' + i"
                            type="button"
                            :data-bs-target="'#carousel-' + report.id"
                            :data-bs-slide-to="i"
                            :class="{ active: i === 0 }"
                            aria-current="i === 0 ? 'true' : undefined"
                            :aria-label="'Slide ' + (i + 1)"
                          ></button>
                        </div>

                        <!-- Carousel Inner -->
                        <div class="carousel-inner">
                          <div
                            v-for="(src, i) in getCarouselImages(report)"
                            :key="'carousel-img-' + i"
                            :class="['carousel-item', { active: i === 0 }]"
                          >
                            <img :src="src.file.url" alt="Feed Image" class="carousel-img media-item rounded-5"
                            @click="display_comment_modal(report)" />
                          </div>
                        </div>

                        <!-- Controls -->
                         <div v-if="getCarouselImages(report).length>1">
                        <button
                          class="carousel-control-prev"
                          type="button"
                          :data-bs-target="'#carousel-' + report.id"
                          data-bs-slide="prev"
                        >
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button
                          class="carousel-control-next"
                          type="button"
                          :data-bs-target="'#carousel-' + report.id"
                          data-bs-slide="next"
                        >
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
                        </div>
                      </div>
                    </div>
                 <div
                    class="d-flex flex-column"
                    v-if="report.report_files && report.report_files.length"
                  >
                  <div class="d-flex flex-column" v-if="report.report_files && report.report_files.length">
                    <div v-for="(fileObj, index) in report.report_files" :key="index" class="mb-3">
                    <!-- ✅ IMAGE FILES -->
                    <div
                      class="media-container image-only mb-3"
                      v-if="fileObj?.file?.url &&
                            (fileObj.file.url.includes('.jpg') ||
                            fileObj.file.url.includes('.JPG') ||
                            fileObj.file.url.includes('.png') ||
                            fileObj.file.url.includes('.PNG') ||
                            fileObj.file.url.includes('.avif') ||
                            fileObj.file.url.includes('.AVIF') ||
                            fileObj.file.url.includes('.jpeg') ||
                            fileObj.file.url.includes('.JPEG') ||
                            fileObj.file.url.includes('.webp') ||
                            fileObj.file.url.includes('.WEBP'))"
                    >
                      <!-- <img
                        :src="fileObj.file.url"
                        alt="Feed Image"
                        class="media-item rounded-5"
                        @click="display_comment_modal(report)"
                      /> -->
                    </div>

                    <!-- ✅ AUDIO FILES -->
                    <div
                      class="media-container video-audio mb-3"
                      v-else-if="fileObj?.file?.url &&
                                (fileObj.file.url.includes('.mp3') ||
                                  fileObj.file.url.includes('.wav'))"
                    >
                      <audio controls class="rounded-3 p-1">
                        <source
                          :src="fileObj.file.url"
                          :type="fileObj.file.url.includes('.mp3') ? 'audio/mpeg' : 'audio/wav'"
                        />
                        Your browser does not support the audio element.
                      </audio>
                    </div>

                    <!-- ✅ VIDEO FILES -->
                    <div
                      class="media-container video-audio mb-3"
                      v-else-if="fileObj?.file?.url && /\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)"
                    >
                      <video controls class="media-item rounded-5" @click="display_comment_modal(report)">
                        <source :src="fileObj.file.url" />
                        Your browser does not support the video tag.
                      </video>
                    </div>

                    <!-- ✅ OTHER FILES (PDF, DOCX, ZIP, ETC.) -->
                    <div v-else class="uploaded-file" @click="display_comment_modal(report)">
                      <img
                        v-if="fileObj?.file?.url"
                        :src="getFileIcon(fileObj.file.url)"
                        class="file-icon small-icon"
                      />
                      <span class="file-name text-break">
                        {{ getFileName(fileObj?.file?.url) }}
                      </span>
                      <a
                        :href="fileObj?.file?.url"
                        download
                        :title="getFileName(fileObj?.file?.url)"
                        class="download-btn"
                        @click.stop
                      >
                        <img
                          src="https://cdn-icons-png.flaticon.com/128/724/724933.png"
                          class="download-icon"
                        />
                      </a>
                    </div>
                    </div>
                  </div>
                </div>
                <div v-if="report.linkPreview" class="link-preview rounded mt-2 p-2 position-relative border">

                        <a :href="report.report_link" target="_blank" class="stretched-link text-decoration-none">
                        <img v-if="report.linkPreview.image" :src="report.linkPreview.image" class="img-fluid rounded" />
                        <div class="fw-bold mt-2">{{ report.linkPreview.title }}</div>
                        <div v-if="!report.linkPreview.image" class="text-muted small">{{ report.linkPreview.description }}</div>
                        </a>
                      </div>

                <!-- Likes and Comments Count -->
                <div class="text-gray mx-2 mt-1 text-end">
                  <span class="me-2" @click="open_likes_modal(report.likes)" data-bs-toggle="modal" data-bs-target="#likes_modal">
                    {{ report.total_likes }}
                    <img src="@/assets/images/like (1).png" class="mb-2" width="16" height="16" alt="">
                  </span>
                  <span>{{ report.total_comments }}
                    <img src="@/assets/images/speech-bubble.png" alt="" width="16" height="16">
                  </span>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex justify-content-between align-items-center border-top border-bottom px-2 py-1 flex-wrap mb-2">
                  <div class="d-flex align-items-center me-3">
                    <span class="d-flex align-items-center fw-500" @click.stop="likeReport(report)">
                      <img src="@/assets/images/like.png" alt="" width="20" height="20">
                      <span class="text-purple text-xxs mx-1">Like</span>
                    </span>
                  </div>
                  <div :class="`d-flex align-items-center me-3 ${!report.can_comment ? 'comment-disabled' : 'pointer'}`" @click="activeCommentReportId = report.id">
                    <img src="@/assets/images/speech-bubble.png" alt="" width="20" height="20">
                    <span class="fw-500 text-xxs mx-1">Comment</span>
                  </div>

                </div>
                <div class="d-flex align-items-center border rounded-pill mb-3 p-0" v-if="activeCommentReportId === report.id">
                    <img :src="activeProfile?.profile_type === 'personal'
                              ? (activeProfile?.user?.profile?.profile_files?.[0]?.file?.url || require('@/assets/images/user.png'))
                              : (activeProfile?.company?.base_profile?.profile_files?.[0]?.file?.file_url || require('@/assets/images/user.png'))"
                          alt="User" class="rounded-circle mx-2" width="32" height="32">
                    <input type="text" class="form-control border-0 rounded-5" id="comment_text_area" v-model="commentText" placeholder="Write a comment" aria-label="Recipient's username" aria-describedby="button-addon2">
                    <div class="d-flex align-items-center">
                      <button class="btn btn-sm text-xxs" type="button" id="button-addon2"  @click="submit_comment(report.id)"><i class="bi bi-send fs-5"></i></button>
                    </div>
                  </div>
            <!-- Comments Component -->
                <Comments
                  ref="commentsRef"
                  :comments="report.comments"
                  :report-id="report.id"
                  :key="report.id"
                  :activeProfile="activeProfile"
                />




          </div>
  </div>
            </div>

              <div v-if="is_loading" class=" text-center">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>

            <div v-else class=" text-center">No available Feeds</div>
          </div>
          </div>

          <!-- Exchange Hub Tab Content -->
          <div class="tab-pane fade h-100" id="top_loans_info" role="tabpanel" aria-labelledby="top_loans_tab">

          </div>
        </div>
      </div>
    </div>
    <!-- Right Sidebar -->
    <div class="col-md-3 border-start">

    </div>
  </div>

  <div class="modal fade" id="edit_voice_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">edit your voice</h5>
          <button type="button" class="btn-close  text-xxs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="edit_createHub">
          <div class="modal-body">
            <div class="mb-3">
              <label for="name" class="form-label text-xxs fw-500">Feed Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control rounded-5 text-xxs" id="edit_name"value="edit_name" placeholder="Enter voice name"
                v-model="edit_name">
                <p v-if="errors.edit_voice_name" class="text-danger text-xxs">{{ errors.edit_voice_name }}</p>
            </div>
            <QuillEditor theme="snow"
            v-model="edit_description"
            ref="quillHubRef"
            class="quill-editor"
            toolbar="full" />
            <div class="d-flex mt-2 mx-1 justify-content-between align-items-start">
              <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
                <label for="editVoiceFileInput" class="text-xxs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                  <i class='bx bx-image-add file-upload-icon'></i> Add voice content
                </label>
                <input type="file" id="editVoiceFileInput" class="file-input d-none" @change="handleHomeFilterFileUpload"/>
                <div v-if="editFileName" class="text-xxs text-secondary fst-italic mt-1">
                  <span class="fw-500">File name:</span> {{ editFileName }}
                </div>
                <div v-if="fileError" class="text-xxs text-danger fst-italic mt-1">{{ fileError }}</div>
              </div>

              <div class="file-upload ms-5 my-2 mx-3 flex-grow-1 d-flex flex-column align-items-center">
                <label for="audioInput" class="text-xxs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                  <i class='bx bx-music'></i> Upload Audio
                </label>
                <input type="file" accept="audio/*" id="audioInput" class="file-input d-none" @change="handleAudioUpload" />
                <div v-if="audioError" class="text-xxs text-danger fst-italic mt-1">{{ audioError }}</div>
              </div>
              <div class="d-flex flex-column align-items-center my-2 flex-grow-1">
                <div class="d-flex flex-row align-items-center mb-3">
                  <button type="button" class="btn btn-primary text-xxs rounded-5 mx-2 d-flex align-items-center justify-content-center" @click="startRecording" v-if="!isRecording">
                    <i class='bx bx-microphone'></i> Record
                  </button>
                  <button type="button" class="btn btn-danger text-xxs rounded-5 mx-2 d-flex align-items-center justify-content-center" @click="stopRecording" v-if="isRecording">
                    <i class='bx bx-stop'></i> Stop
                  </button>
                </div>
                <div v-if="audio_file_name" class="text-xxs text-secondary fw-500 mb-3 audio-file">
                  <i class='bx bx-music'></i> Recorded: {{ audio_file_name }}
                </div>
              </div>
            </div>


            <div class="d-flex flex-column" v-if="edit_documents.document && edit_documents.document.length">
              <div class="row g-3">
                <div v-for="(fileObj, index) in edit_documents.document" :key="index" class="col-4 mb-3">

                  <img v-if="fileObj.file.file_url.includes('.jpg') || fileObj.file.file_url.includes('.png') || fileObj.file.file_url.includes('.jpeg')"
                       :src="fileObj.file.file_url"
                       alt="File Image"
                       class="img-fluid rounded-5"
                       style="max-height: 150px; object-fit: cover;"/>


                  <audio v-else-if="fileObj.file.file_url.includes('.mp3') || fileObj.file.file_url.includes('.wav')"
                         controls
                         class="w-100 rounded-5">
                    <source :src="fileObj.file.file_url" type="audio/mp3">
                    Your browser does not support the audio element.
                  </audio>


                  <!-- Video -->
                  <video v-else-if="/\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.file_url)" controls
                  class="img-fluid rounded-5 w-100">
                  <source :src="fileObj.file.file_url">
                  Your browser does not support the video tag.
                </video>

                <!-- PDF -->
                <iframe v-else-if="fileObj.file.file_url.includes('.pdf')"
                  :src="'https://docs.google.com/viewer?url=' + encodeURIComponent(pdf_file_url) + '&embedded=true'"
                  frameborder="0" width="100%" height="500px">
                </iframe>

                <!-- Word Document -->
                <iframe
                  v-else-if="fileObj.file.file_url.includes('.docx') || fileObj.file.file_url.includes('.doc')"
                  :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                  frameborder="0" width="100%" height="500px">
                </iframe>

                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded-5">Post</button>
          </div>
        </form>

            </div>
      </div>
  </div>

  <div class="modal fade" id="edit_report_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">edit your feed</h5>
          <button type="button" class="btn-close  text-xxs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="edit_report_data">
          <div class="modal-body">
            <div v-if="topics.length > 0" class="mb-2">
            <label class="form-label text-xxs fw-500">Segment (Topic)</label>
            <select class="form-select-sm bg-gray fw-500 border-0 rounded-3 text-xxs" v-model="selected_topic"
              id="topic">
              <option value="" selected hidden>Tag a segment</option>
              <option v-for="topic in topics" :value="topic.id" :key="topic.id">
                {{ topic.name }}
              </option>
            </select>
          </div>
          <div class="d-flex align-items-center mb-3">
              <label for="toggle-comments" class="form-label mb-0 me-3 text-xs fw-500">Allow comments:</label>
              <div class="form-check form-switch ">
                <input class="form-check-input" type="checkbox" id="toggle-comments" v-model="comments_off">
                <label class="form-check-label" for="toggle-comments ms-2">{{ comments_off ? 'Yes' : 'No' }}</label>
              </div>
            </div>
            <QuillEditor theme="snow"
            v-model="report_description"
            ref="quillReportRef"
            class="quill-editor"
            toolbar="full" />
            <div class="d-flex mt-2 mx-1 justify-content-between align-items-start flex-wrap">
  <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
    <label for="editReportFileInput"
      class="text-xxs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
      <i class='bx bx-image-add file-upload-icon'></i> Add Feed content
    </label>
    <input type="file" id="editReportFileInput" class="file-input d-none" @change="handleHomeFileUpload" />

    <!-- Truncated File Name -->
    <div v-if="editFileName" class="file-name text-xxs text-secondary fst-italic mt-1" :title="editFileName">
      <span class="fw-500">File name:</span> {{ editFileName }}
    </div>

    <!-- Error Message -->
    <div v-if="fileError" class="text-xxs text-danger fst-italic mt-1">{{ fileError }}</div>
  </div>

  <!-- Audio Upload -->
  <div class="file-upload ms-5 my-2 mx-3 flex-grow-1 d-flex flex-column align-items-center">
    <label for="audioInput"
      class="text-xxs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
      <i class='bx bx-music'></i> Upload Audio
    </label>
    <input type="file" accept="audio/*" id="audioInput" class="file-input d-none" @change="handleAudioUpload" />
    <div v-if="audioError" class="text-xxs text-danger fst-italic mt-1">{{ audioError }}</div>
  </div>

  <!-- Audio Recorder -->
  <div class="d-flex flex-column align-items-center my-2 flex-grow-1">
    <div class="d-flex flex-row align-items-center mb-3">
      <button type="button"
        class="btn btn-primary text-xxs rounded-5 mx-2 d-flex align-items-center justify-content-center"
        @click="startRecording" v-if="!isRecording">
        <i class='bx bx-microphone'></i> Record
      </button>
      <button type="button"
        class="btn btn-danger text-xxs rounded-5 mx-2 d-flex align-items-center justify-content-center"
        @click="stopRecording" v-if="isRecording">
        <i class='bx bx-stop'></i> Stop
      </button>
    </div>
    <div v-if="audio_file_name" class="text-xxs text-secondary fw-500 mb-3 audio-file">
      <i class='bx bx-music'></i> Recorded: {{ audio_file_name }}
    </div>
  </div>
</div>
            <div class="d-flex flex-column" v-if="edit_documents.report_files && edit_documents.report_files.length">
              <div class="row g-3">
                <div v-for="(fileObj, index) in edit_documents.report_files" :key="index" class="position-relative mb-3">

                  <!-- Image -->
                  <img v-if="fileObj.file.file_url.includes('.jpg') || fileObj.file.file_url.includes('.png') || fileObj.file.file_url.includes('.jpeg')"
                       :src="fileObj.file.file_url"
                       alt="Feed Image"
                       class="img-fluid rounded-5 w-100 h-100"
                       :class="{ 'zoomed-in': isZoomed }"
                       @click="display_comment_modal(report)"
                       ref="image" />

                  <!-- Audio -->
                  <audio v-else-if="fileObj.file.file_url.includes('.mp3') || fileObj.file.file_url.includes('.wav')"
                         controls
                         class="w-100 rounded-5">
                    <source :src="fileObj.file.file_url" type="audio/mp3" />
                    Your browser does not support the audio element.
                  </audio>

                  <!-- Video -->
                  <video v-else-if="/\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.file_url)" controls
                         class="img-fluid rounded-5 w-100">
                    <source :src="fileObj.file.file_url" />
                    Your browser does not support the video tag.
                  </video>

                  <!-- PDF -->
                  <iframe v-else-if="fileObj.file.file_url.includes('.pdf')"
                          :src="'https://docs.google.com/viewer?url=' + encodeURIComponent(fileObj.file.file_url) + '&embedded=true'"
                          frameborder="0" width="100%" height="500px">
                  </iframe>

                  <!-- Word Document -->
                  <iframe v-else-if="fileObj.file.file_url.includes('.docx') || fileObj.file.file_url.includes('.doc')"
                          :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                          class="img-fluid rounded-5 w-100">
                  </iframe>

                  <!-- Excel Document -->
                  <iframe v-else-if="fileObj.file.file_url.includes('.xls') ||
                                      fileObj.file.file_url.includes('.xlsx') ||
                                      fileObj.file.file_url.includes('.xlsm') ||
                                      fileObj.file.file_url.includes('.xlsb')"
                          :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                          frameborder="0" width="100%" height="500px">
                  </iframe>

                </div>

              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded-5">Post</button>
          </div>
        </form>
            </div>
      </div>
  </div>
<!-- </section> -->

<StickyNav/>


<!-- Commenting modal -->
<ReportCommentModal v-if="comment_modal_visible"
  :report_data="report_data"
  @hide_comment_comment="hide_comment_comment"
/>


